module.exports = __webpack_public_path__ + "img/3ffbf8eea1d15fc2f8d7f6e2ebd4ed97.svg";